export default __webpack_public_path__ + "static/media/icon_role.f473f32f.svg";